import { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import Header from '../../component/Header';
import './style.css';
import IconTotlaUser from '../../component/SvgIcons/IconTotlaUser';
import IconOnlineEvent from '../../component/SvgIcons/IconOnlineEvent';
import IconOfflineEvents from '../../component/SvgIcons/IconOfflineEvents';
import IconUpcomingEvents from '../../component/SvgIcons/IconUpcomingEvents';
import { Link } from 'react-router-dom';
import api from '../../Services/api';

import { todayInCountry } from "../../Services/countryTime";
export default function Dashboard() {
  // State for counts
  const [counts, setCounts] = useState({
    totalUsers: 0,
    upcomingEvents: 0,
    offlineEvents: 0,
    onlineEvents: 0
  });

  const fetchTotalUsers = async () => {
    try {
      const response = await api.post('/getAllUsers');
      setCounts(prevCounts => ({
        ...prevCounts,
        totalUsers: response.data.length || 0
      }));
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };


  const fetchEventCounts = async () => {
    try {
      const response = await api.post('/eventview');     
      console.log("response", response.data);
  
      // Assuming `response.data` contains an array of events
      const events = response.data || [];
      const today = todayInCountry();
      const upcomingEvents = events.filter(event => event.event_date > today).length;
      // Count online and offline events
      const onlineEvents = events.filter(event => event.ModeOfMeeting === "Online Meeting").length;
      const offlineEvents = events.filter(event => event.ModeOfMeeting === "Offline Meeting").length;
  
      setCounts(prevCounts => ({
        ...prevCounts,
        onlineEvents,
        offlineEvents,
        upcomingEvents // Assuming all events are upcoming
      }));
    } catch (error) {
      console.error('Error fetching event counts:', error);
    }
  };

  
    // Fetch events count (simulated for now)
    useEffect(() => {
      fetchTotalUsers();
      fetchEventCounts();
    }, []);

  return (
    <section className='dashboardpage'>
      <Header pageTitle="Dashboard"/>
      <div className="pageLeftspace">
        <div className="d-flex justify-content-between align-items-center topsearchbar gap-5">
          <Link to="/users-list" className='dashbordboxes d-flex flex-column-reverse gap-2'>
            <h2>Total Users</h2>
            <div className='boxcount d-flex align-items-center justify-content-between'>
            <CountUp end={counts.totalUsers} duration={5} />
            <h5><IconTotlaUser/></h5>
            </div>
          </Link>

          <Link to="/events" className='dashbordboxes d-flex flex-column-reverse gap-2'>
            <h2>Online Events</h2>
            <div className='boxcount d-flex align-items-center justify-content-between'>
            <CountUp end={counts.onlineEvents} duration={2} />
            <h5><IconOnlineEvent/></h5>
            </div>
          </Link>
        
          <Link to="/events"  className='dashbordboxes d-flex flex-column-reverse gap-2'>
            <h2>Offline Events</h2>
            <div className='boxcount d-flex align-items-center justify-content-between'>
            <CountUp end={counts.offlineEvents} duration={2} />
            <h5><IconOfflineEvents/></h5>
            </div>
          </Link>
      

          <Link to="/events" className='dashbordboxes d-flex flex-column-reverse gap-2'>
            <h2>Upcoming Events</h2>
            <div className='boxcount d-flex align-items-center justify-content-between'>
            <CountUp end={counts.upcomingEvents} duration={2} />
            <h5><IconUpcomingEvents/></h5>
            </div>
          </Link>

        </div>
      </div>
    </section>
  );
}
